import { render, staticRenderFns } from "./DeliverDialog.vue?vue&type=template&id=a0365512"
import script from "./DeliverDialog.vue?vue&type=script&lang=js"
export * from "./DeliverDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0365512')) {
      api.createRecord('a0365512', component.options)
    } else {
      api.reload('a0365512', component.options)
    }
    module.hot.accept("./DeliverDialog.vue?vue&type=template&id=a0365512", function () {
      api.rerender('a0365512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/internal/components/LogisticsTable/DeliverDialog.vue"
export default component.exports